<template>
  <SloTabs
    id="auth"
    class="slo-auth"
    v-model="tab"
    @input="handleInput"
  >
    <template v-slot:header>
      <slot name="auth-header" />
    </template>
    <SloTab name="login" component="slo-auth-login">
      {{ 'Log In' | t }}
    </SloTab>
    <SloTab name="register" component="slo-auth-register">
      {{ 'Create an Account' | t }}
    </SloTab>
  </SloTabs>
</template>

<script>
import t from '../../js/main/i18n';
import {initializeClickwrap} from '../../js/main/utils';
import SloTabs from './SloTabs.vue';
import SloTab from './SloTab.vue';

export default {
  name: 'SloAuth',
  components: {
    SloTabs,
    SloTab
  },
  filters: {
    t
  },
  props: {
    initialTab: String
  },
  data() {
    return {
      tab: 'login',
      clickwrapGroup: 'sloan-registration'
    };
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('redirect') && !urlParams.has('sessionExpired')) {
      this.$snotify.info(t('Please sign in to access that page'));
    }

    if (this.initialTab) {
      this.tab = this.initialTab;
    }
  },
  mounted() {
    initializeClickwrap(this.clickwrapGroup, 'clickwrap-container-auth');
  },
  methods: {
    handleInput($event) {
      this.$emit('change', $event);
      initializeClickwrap(this.clickwrapGroup, 'clickwrap-container-auth');
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/system';

.sections {
  padding-top: 20px;
  margin-bottom: 32px;
}

.slo-auth {
  &.slo-tabs main {
    overflow: initial;
  }
}
</style>
